var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items&&_vm.items.length)?_c('div',{staticClass:"secondNav"},_vm._l((_vm.items),function(v,i){return _c('router-link',{key:i,staticClass:"link",attrs:{"to":v.to}},[_vm._v(_vm._s(v.text))])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }